import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  IApiResponse,
  ICreatePalletsResponse,
  IImportBay4sRequest,
} from "model";
import { IErrorResponse } from "model/Common/IErrorResponse";
import { call, put, takeEvery } from "redux-saga/effects";
import { ReportActions } from "redux/actions";
import { ReportApiService } from "services";

function* importBay4sReport(action: PayloadAction<IImportBay4sRequest>) {
  try {
    const result: ICreatePalletsResponse = yield call(
      ReportApiService.importBay4s,
      action.payload
    );
    if (result.succeeded) {
      yield put(ReportActions.importBay4s.success(result.data!));
      AlertHelper.showAlert(
        "Import Inventory Reconciliation Report Document Successfully",
        EAlertType.SUCCESS
      );
    } else {
      const error = result as IErrorResponse;
      yield put(ReportActions.importBay4s.failed(error));
    }
  } catch (error) {
    yield put(ReportActions.importBay4s.failed(error));
  }
}
export function* Watcher() {
  yield takeEvery(ReportActions.importBay4s.request, importBay4sReport);
}
